// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"c996a729","387":"d523c4e1","461":"338d4724","544":"92c34ee7","582":"96d92831","751":"d523c4e1","918":"cbb1d510"}[chunkId] + ".chunk.css";
};